// extracted by mini-css-extract-plugin
export default {"icon":"ActionToggle_icon__vqgKZ","dark":"ActionToggle_dark__yN-Fj","light":"ActionToggle_light__yVUkf"};